import clsx from 'clsx'
import VimeoVideo from 'components/Common/Video/VimeoVideo'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import IconButton from 'LuxKit/Button/IconButton'
import LineTimesIcon from 'LuxKit/Icons/line/LineTimesIcon'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'

const MainContainer = styled.div`
  position: sticky;
  bottom: 0;
  z-index: ${zIndex.floatingPanel};
`

const Container = styled(Sheet)`
  position: absolute;
  bottom: 0;
  inset-inline-end: 0;
  overflow: hidden;
  box-shadow: ${props => props.theme.shadow.bottom.large};
  border: ${rem(1)} solid ${props => props.theme.palette.neutral.surface.lightForeground};
  margin: ${rem(40)} ${rem(20)};
  width: ${rem(276)};
  display: none;

  &.show {
    display: block;
    animation: slideLeft 0.2s linear forwards;
  }

  @keyframes slideLeft {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`

const CloseButton = styled(IconButton)`
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  margin: ${rem(8)};
  z-index: ${zIndex.floatingBookmarkButton};
`

interface Props {
  isVisible: boolean
  onBookConsultationClick: () => void
  onClose: () => void
}

function WeddingLandingPageSupportModal(props: Props) {
  const { onBookConsultationClick, onClose, isVisible } = props

  const intl = useIntl()

  return (
    <MainContainer>
      <Container borderRadius="L" background="normal-background" className={clsx({ 'show': isVisible })}>
        <CloseButton kind="primary" variant="ghost" size="small" shape="circle" onClick={onClose}>
          <LineTimesIcon />
        </CloseButton>
        <Group direction="vertical">
          <div>
            <VimeoVideo vimeoVideoId="1209662775" query={{ background: true }} />
          </div>
          <Sheet padding="12 16">
            <Group direction="vertical" gap={4}>
              <Group direction="vertical">
                <BodyText variant="large" weight="bold">
                  {intl.formatMessage({
                    id: 'wF4LEAR9YKbsjgJQCuzS',
                    defaultMessage: 'Have any questions?',
                    description: 'Title for the concierge support modal on the weddings landing page',
                  })}
                </BodyText>
                <BodyText variant="small">
                  {intl.formatMessage({
                    id: 'axoll40aknel7DUSP0u2',
                    defaultMessage: 'Our dedicated concierge team is here for you 24/7.',
                    description: 'Description for the concierge support modal on the weddings landing page',
                  })}
                </BodyText>
              </Group>
              <Group direction="horizontal" horizontalAlign="end">
                <TextLink size="caption" weight="bold" onClick={onBookConsultationClick}>
                  {intl.formatMessage({
                    id: 'BdvswPsw6j9RR1bzPesM',
                    defaultMessage: 'Book a free consultation',
                    description: 'Label for the CTA button on the weddings landing page',
                  })}
                </TextLink>
              </Group>
            </Group>
          </Sheet>
        </Group>
      </Container>
    </MainContainer>
  )
}

export default WeddingLandingPageSupportModal
